module.exports = __webpack_public_path__ + "error-9738954c7d.svg";


//////////////////
// WEBPACK FOOTER
// ./ui/ConnectingLoader/error.svg
// module id = 2431
// module chunks = 0